import React from 'react';
import { BiDownload, BiSmile } from 'react-icons/bi';
import { Link } from 'react-scroll';
import avatar from '@assets/placement.png';
import Image from 'next/image';
import { StarIcon } from '@heroicons/react/solid';
import hightlightLines from '@assets/placementpage-images/highlight-line.svg';
import lightBulb from '@assets/placementpage-images/light-bulb.svg';
import quateIcon from '@assets/placementpage-images/quate-icon.svg';
import CircularTestimonialCarousel from './CircularTestimonialCarousel';

const StaticsBox = ({ children }) => {
  return (
    <div className="w-fit rounded-xl bg-white px-5 py-6 shadow-[0px_2px_16px_0px_rgba(240,0,55,0.06)] outline outline-1 outline-rose-100">
      {children}
    </div>
  );
};

const JoinSuccessStory = ({ hereStudentsData, heroSectionStats }) => {
  return (
    <div className="hero-section relative mb-20 flex w-full flex-col  justify-between overflow-hidden pb-[450px] md:pb-[510px]  lg:pb-[0]">
      <div className="relative flex flex-col items-center justify-center px-24 pt-8">
        <div className="absolute left-[258px] top-[214px] md:left-[474px] md:top-[21] lg:left-[174px] lg:top-[81px]">
          <Image
            src={lightBulb}
            width={132}
            height={132}
            alt="lightbulb"
            style={{ transform: 'rotate(-2.914deg)' }}
          />
        </div>
        <div className="relative z-10 flex flex-col items-center px-[16px]">
          <h3 className="whitespace-nowrap text-center font-satoshi-medium text-[18px] font-[500] leading-tight text-[#1f1f1f] lg:text-[28px]">
            <span className="font-[600] text-red">781+</span> Students Placed in 2024,
          </h3>
          <h3 className="whitespace-nowrap text-center font-gellix-bold text-[32px]  leading-tight text-[#1f1f1f] lg:text-[52px]">
            Join the <span className="text-red">Success</span> Story!
          </h3>
          <Image
            src={hightlightLines}
            className="absolute -top-[2px] left-[23px]"
            alt="highlighter"
          />
        </div>

        <div className="mt-4 flex items-center gap-8 font-proxima-nova lg:mt-8">
          <button className="z-10 flex w-fit cursor-pointer items-center justify-center gap-x-4 rounded-[9px] bg-red p-3 text-lg !normal-case text-white focus:outline-none lg:cursor-pointer">
            <BiDownload size={24} />
            <span
              style={{ textWrap: 'nowrap' }}
              className="text-nowrap text-18px cursor-pointer font-proxima-nova lg:cursor-pointer"
            >
              Placement Report
            </span>
          </button>

          <Link href="/courses/full-stack-data-science" className="z-10">
            <span
              style={{ textUnderlinePosition: 'from-font' }}
              className="decoration-skip-ink-none  whitespace-nowrap text-center font-proxima-nova text-[16px] font-[500] capitalize leading-tight text-red underline decoration-solid decoration-auto underline-offset-auto lg:cursor-pointer"
            >
              Explore Courses
            </span>
          </Link>
        </div>
      </div>

      <div className="relative -mt-8 flex  items-start justify-center gap-2 px-24  font-proxima-nova lg:justify-between lg:px-8">
        {' '}
        <div className="grid grid-cols-2 gap-[14px] pt-[100px] pb-20 lg:gap-4 lg:pt-0">
          <div className="flex flex-col items-end justify-end gap-4">
            <StaticsBox>
              <div className="inline-flex flex-col items-start justify-center gap-[10px] rounded-xl lg:gap-2.5 ">
                <div className="justify-start text-center  text-xl font-semibold capitalize text-stone-900">
                  {heroSectionStats?.Stats?.AvgPackage}
                </div>
                <div className="justify-start whitespace-nowrap text-center text-xs font-normal capitalize text-zinc-500">
                  average Package
                </div>
              </div>
            </StaticsBox>
            <StaticsBox>
              <div className="inline-flex flex-col items-start justify-center gap-3.5 ">
                <BiSmile className="h-7 w-7 text-[#e11d48]" />
                <div className="flex flex-col items-start  gap-2.5">
                  <div className="justify-start text-center  text-xl font-semibold capitalize text-stone-900">
                    {heroSectionStats?.Stats?.StudentPlaced}
                  </div>
                  <div className="justify-start  whitespace-nowrap text-xs font-normal capitalize text-zinc-500">
                    Happy Placed Students
                  </div>
                </div>
              </div>
            </StaticsBox>
            <StaticsBox>
              <div className="inline-flex flex-col items-start justify-start gap-2.5">
                <div className="justify-start text-center  text-xl font-semibold capitalize text-stone-900">
                  {heroSectionStats?.Stats?.HighestPackage}
                </div>
                <div className="justify-start whitespace-nowrap  text-center text-xs font-normal capitalize text-zinc-500">
                  Highest Package
                </div>
              </div>
            </StaticsBox>
          </div>
          <div className="flex h-full flex-col items-start justify-center gap-4">
            <StaticsBox>
              <div className="inline-flex flex-col items-start justify-center gap-2.5">
                <div className="flex flex-col items-start justify-center gap-4">
                  <div className="inline-flex items-start justify-start gap-[3px]">
                    <StarIcon className="h-3 w-3 text-[#F3971B]" />
                    <StarIcon className="h-3 w-3 text-[#F3971B]" />
                    <StarIcon className="h-3 w-3 text-[#F3971B]" />
                    <StarIcon className="h-3 w-3 text-[#F3971B]" />
                    <div className="relative">
                      <StarIcon className="h-3 w-3 text-gray-300" /> {/* Empty star */}
                      <div className="absolute top-0 left-0 w-1/2 overflow-hidden">
                        <StarIcon className="h-3 w-3 text-[#F3971B]" /> {/* Half-filled star */}
                      </div>
                    </div>
                  </div>
                  <div className="w-16 justify-start  text-xl font-semibold capitalize text-stone-900">
                    {heroSectionStats?.Stats?.Ratings}/5
                  </div>
                </div>
                <div className="justify-start whitespace-nowrap  text-center text-xs font-normal capitalize text-zinc-500">
                  Student Rating
                </div>
              </div>
            </StaticsBox>
            <StaticsBox>
              <div className="inline-flex flex-col items-start justify-start gap-2.5">
                <div className="justify-start text-center  text-xl font-semibold capitalize text-stone-900">
                  {heroSectionStats?.Stats?.AvgHike}
                </div>
                <div className="justify-start whitespace-nowrap  text-center text-xs font-normal capitalize text-zinc-500">
                  Average Hike
                </div>
              </div>
            </StaticsBox>
          </div>
        </div>
      </div>
      <div className="absolute left-1/2 bottom-[-10%] -translate-x-1/2 transform md:bottom-[-10%] lg:bottom-[-10%] xl:bottom-[-15%]">
        <CircularTestimonialCarousel hereStudentsData={hereStudentsData} />
      </div>
    </div>
  );
};

export default JoinSuccessStory;
